const state = {
    item: {},
    detail : {},
    items: []
};

export default state;